import { Button, Modal } from "react-bootstrap";

//Confirmation model popup
export function RedirectConfirmationModal(props) {
  const {
    show,
    animate,
    ModalSize,
    SubmitButtonVariant,
    SubmitButtonClasses,
    SubmitButtonStyle,
    SubmitButtonText,
    CancelButtonVariant,
    CancelButtonClasses,
    CancelButtonText,
    onClose,
    Title,
    message,
    onConfirm,
    onDiscard,
  } = props;

  return (
    <Modal
      show={show}
      onHide={onClose}
      animation={animate}
      size={ModalSize}
      className="react-survey-modal"
    >
      <div className="confirm-popup">
        <Modal.Header closeButton>
          <Modal.Title>{Title}</Modal.Title>
        </Modal.Header>
      </div>
      <Modal.Body className="pb-15">
        <p>{message}</p>
      </Modal.Body>
      <div className="container">
        <Modal.Footer className="row">
          <Button
            variant={SubmitButtonVariant}
            className={`col-2 confirmModal-submit-button ${SubmitButtonClasses}`}
            style={SubmitButtonStyle}
            onClick={(e) => {
              onConfirm(e);
              onClose();
            }}
          >
            {SubmitButtonText}
          </Button>

          <Button
            variant={CancelButtonVariant}
            className={`${CancelButtonClasses} ${"col-md-2 col-3 confirm-popup-buttonS"}`}
            onClick={onDiscard}
          >
            {CancelButtonText}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}
